import React from 'react';

import {AutoSizer} from 'react-virtualized';
import {CommentContent} from '@/views/storyboard/charts/comment/CommentContent';


interface Props {
    queryData: {comment: string};
    chartTitle: string;
}

const CommentWrapper = React.memo<Props>((
    {
        queryData,
        chartTitle,
    },
) => (
    <AutoSizer>
        {({width, height}) => (
            <CommentContent
                width={width}
                height={height}
                htmlContent={queryData?.comment || ''}
                chartTitle={chartTitle}
            />
        )}
    </AutoSizer>
));


export default CommentWrapper;
